@let withCallWaiterMain = this.withCallWaiterMain();

<app-language-switcher class="language-switcher"/>

<div class="title">
  {{ 'serviceCenter.title' | translate }}
</div>

<div class="table" [class.large]="!withCallWaiterMain">
  <img class="logo" src="/images/logo.svg" width="76" height="76" alt=""/>
  <div class="name">
    {{ 'serviceCenter.table' | translate }} {{ table()?.tableName }}
  </div>
</div>

@if (withCallWaiterMain) {
  <app-call-waiter-main-button
    class="call-waiter"
    coreActivitySection="CallWaiter"
    [coreUserActivityClickTracking]="callWaiterMain() ? 'CancelCallWaiter' : 'CallWaiter'"
  />
}

<app-service-center-sections class="sections"/>

<app-service-center-amenities class="amenities"/>
